import { useEffect, useRef } from "react";

export default function ModalFooter({ gallery }) {

    const activeRef = useRef(null);

    useEffect(() => {

        activeRef.current?.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest",

        });

    }, [gallery.selected]);

    return (

        <div className="gallery-footer">

            <div className="gallery-thumbnails">

                {gallery.images.map(image => (

                    <button

                        key={image.id}

                        ref={
                            gallery.selected.id === image.id
                                ? activeRef
                                : null
                        }

                        className={
                            gallery.selected.id === image.id
                                ? "gallery-thumb active"
                                : "gallery-thumb"
                        }

                        onClick={() => gallery.selectImage(image)}

                    >

                        <img
                            src={image.url}
                            alt=""
                            loading="lazy"
                        />

                    </button>

                ))}

            </div>

        </div>

    );

}